import $ from 'jquery';

$(function () {
  $('.delete-row').click(function (e) {
    var row = $(this).closest('tr');
    $(row).addClass('to-be-removed');
    var result = window.confirm('Remove this row from the list?');
    if (result === false) {
      e.preventDefault();
      $(row).removeClass('to-be-removed');
    } else {
      $(row).remove();
    }
  });

  $('select#bulk_invitation_employee_role').change(function () {
    if ($(this).val() == 'agent') {
      $('#js-bulk_invitation_agent_team_select').show();
      $('#js-bulk_invitation_manager_team_select').hide();
    } else {
      $('#js-bulk_invitation_agent_team_select').hide();
      $('#js-bulk_invitation_manager_team_select').show();
    }
  });
});
